class Controller {
  constructor($log) {
    "ngInject";
    $log.log("It's paymentMethods Component");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/paymentMethods/paymentMethods.controller.js